import { Audit, Finding, FindingStatus } from '../../audit.model';
import { Component, OnInit, EventEmitter } from '@angular/core';
import { filter, switchMap } from 'rxjs/operators';
import { FindingService } from '../../finding.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { BreadcrumbItem } from '../../../shared/shared.model';
import { AuditService } from '../../audit.service';
import { MatDialog } from '@angular/material';
import { FindingEditDialogComponent } from '../finding-edit-dialog/finding-edit-dialog.component';
import { OkCancelDialogComponent } from '../../../shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import { DISPLAY_DATE_FORMAT } from 'src/app/app.constants';

@Component({
  selector: 'iaud-finding-detail',
  templateUrl: './finding-detail.component.html',
  styleUrls: ['./finding-detail.component.scss']
})
export class FindingDetailComponent implements OnInit {
  dateFormat: string = DISPLAY_DATE_FORMAT;

  auditId: number;
  findingId: number;
  finding: Finding;
  auditTitle: string;
  audit: Audit;
  findingStatus = FindingStatus;
  isMarkingReady$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  reloadCapa: EventEmitter<boolean> = new EventEmitter<boolean>();
  toEvidence: boolean = false;

  breadcrumbs: Array<BreadcrumbItem> = [
    {
      title: 'Home',
      path: '/home',
    }
  ];

  constructor(
    private route: ActivatedRoute,
    private findingService: FindingService,
    private auditService: AuditService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.route.paramMap.pipe(
      switchMap((params: ParamMap): Observable<Finding> => {
        this.auditId = +params.get('auditId');
        if (this.auditId > 0) {
          let b = {
            title: 'Audit:',
            path: `/audit/${this.auditId}`,
          };
          this.breadcrumbs.push(
            {
              title: 'All audits',
              path: '/audit',
            });
          this.breadcrumbs.push(b);
          this.auditService.getAudit(this.auditId)
            .subscribe(a => {
              this.audit = a;
              b.title = `Audit: ${a.auditTitle}`;
            });
        } else {
          this.breadcrumbs.push(
            {
              title: 'All Findings',
              path: '/audit/all/findings',
            });
        }
        this.findingId = +params.get('findingId');

        return this.findingService.getFinding(this.findingId, this.auditId);
      })
    )
      .subscribe(v => {
        this.finding = v;
        this.toEvidence = v.status === this.findingStatus.PENDING;
        this.breadcrumbs.push({
          title: `Finding: ${this.finding.findingTitle}`,
          path: '',
        });
      });
  }
  editFinding(): void {
    const dialogRef = this.dialog.open(FindingEditDialogComponent, { data: { finding: this.finding } });

    dialogRef.afterClosed()
      .pipe(
        filter(res => res && res.success)
      )
      .subscribe(res => {
        this.findingService.getFinding(res.findingId)
          .subscribe(o => this.finding = o);
      });
  }
  markAsReady(): void {
    const dlgData = {
      data: {
        title: 'Mark as Ready to Submit the entire Finding?',
        text: '',
        okText: 'Ready To Submit',
      },
    };
    if (this.finding.draftCapaCount === 0) {
      dlgData.data.text =
        `<b>${this.finding.findingTitle}</b> audit ${this.finding.capaCount} CAPA/ECs are about to be mark as ready to submit.` +
        `<br>You can't undo this action`;
    } else {
      dlgData.data.text = `${this.finding.draftCapaCount}/${this.finding.capaCount} CAPA/ECs are draft!` +
        `<br><br><b>${this.finding.findingTitle}</b> audit ${this.finding.capaCount} CAPA/ECs are about to be mark as ready to submit.` +
        `<br>You can't undo this action`;
    }
    const dialogRef = this.dialog.open(OkCancelDialogComponent, dlgData);
    dialogRef.afterClosed().subscribe(result => {
      this.reloadCapa.emit(true);

      if (result) {
        this.findingService.markAsReady(this.findingId)
        .subscribe((res: boolean) => {
          if (res) {
            this.reloadCapa.emit(true);
            this.findingService.getFinding(this.findingId)
              .subscribe(o => this.finding = o);
          }
        });
        }
    });
  }
  canReady(): boolean {
    return this.finding.capaCount > 0;
  }
}
